import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { Truck, CreditCard, UserCheck } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const perks = [
  { icon: Truck, title: "Free shipping over $150", text: "Orders under $150 ship for a flat $9." },
  { icon: CreditCard, title: "Pay by debit or credit card", text: "Encrypted checkout powered by Stripe." },
  { icon: UserCheck, title: "Guest or account", text: "Check out fast, or sign in to track orders." },
];

export function Spotlight() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-32" data-testid="spotlight-section">
      <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] bg-[var(--terra)] lg:col-span-6">
          <motion.img src="/img/serum.jpg" alt="Glow Vitamin C Serum" style={{ y, scale: 1.25 }} className="absolute inset-0 h-full w-full object-cover" />
          <span className="eyebrow absolute left-5 top-5 rounded-full bg-[var(--bone)] px-3 py-1.5 !text-[10px]">Spotlight</span>
        </div>
        <div className="lg:col-span-6">
          <Reveal>
            <p className="eyebrow text-[var(--terra-deep)]">Product of the week</p>
            <h2 className="font-display mt-4 text-4xl leading-[1.02] tracking-tight md:text-6xl">The serum the internet <span className="italic">can't stop</span> reordering.</h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-[var(--ink-soft)]">15% vitamin C with hyaluronic acid, for brighter, plumper-looking skin in a few drops a day.</p>
            <Link to="/product/glow-vitamin-c-serum" className="mt-8 inline-flex rounded-full border border-[var(--ink)] px-7 py-3.5 text-sm font-semibold transition-colors hover:bg-[var(--ink)] hover:text-[var(--bone)]" data-testid="spotlight-shop-link">Shop Glow Serum — $38</Link>
          </Reveal>
          <div className="mt-14 grid gap-px overflow-hidden rounded-2xl border border-[var(--line)] bg-[var(--line)] sm:grid-cols-3">
            {perks.map(({ icon: Icon, title, text }, i) => (
              <Reveal key={title} delay={i * 0.08} y={20} className="bg-[var(--bone)] p-6">
                <Icon size={22} className="text-[var(--terra-deep)]" />
                <p className="mt-4 text-sm font-semibold">{title}</p>
                <p className="mt-1 text-xs leading-relaxed text-[var(--ink-soft)]">{text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
